import LayoutMain from './Layouts/LayoutMain';

const NotPermission = () => (
	<LayoutMain>
		<div id="content">
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">PCRF/PCF</h1>

						<div className="d-flex justify-content-center align-content-center">
							<h1 style={{marginTop: '16rem'}}>
								Please select an option in the left menu
							</h1>
						</div>
					</div>
				</div>
			</div>
		</div>
	</LayoutMain>
);

export default NotPermission;
